import styled from '@emotion/styled'
import { LocalizationProvider, TimePicker as MuiTimerPicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

const Wrapper = styled.div`
  input {
    padding: 12px 8px;
    margin: 0;
    box-sizing: border-box;
    color: var(--Graphite);
    border: solid 1px var(--White80);
    vertical-align: middle;
    height: auto;
  }
  .MuiIconButton-root {
    color: var(--Red-Dark);
  }
`

export type TimePickerProps = {
  disabled?: boolean
  onChange: (time?: Date) => void
  value: Date | null
}

export const TimePicker = ({ disabled, onChange, value }: TimePickerProps) => (
  <Wrapper>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiTimerPicker
        aria-label="change date"
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
    </LocalizationProvider>
  </Wrapper>
)
